import { WorkflowContext } from '@/providers/ftue-workflow';
import { useContext } from 'react';

export function useWorkflow() {
    return useContext(WorkflowContext);
}
